<template>
  <div
    class="reviews-counter"
    :class="[
      size ? 'reviews-counter--' + size : '',
      { 'reviews-counter--not--adaptive': notAdaptive },
      { 'reviews-counter--empty': !value }
    ]"
  >
    <a :href="productLink + '?tab=comments'" @click="goToReviews" class="reviews-counter__link link">
      <svg
        class="reviews-counter__svg"
        width="15"
        height="11"
        viewBox="0 0 15 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.40311 7.53313L1.76052 9.3189L3.62496 8.70716L4.04236 8.91648C4.64754 9.21996 5.33676 9.39212 6.07131 9.39212H9.53565C11.95 9.39212 13.9071 7.52324 13.9071 5.21785C13.9071 2.91246 11.95 1.04357 9.53565 1.04357H6.07131C3.65701 1.04357 1.69983 2.91246 1.69983 5.21785C1.69983 5.91164 1.87623 6.56304 2.18759 7.13631L2.40311 7.53313ZM0 11L1.21743 7.61676C0.827351 6.89855 0.606961 6.08278 0.606961 5.21785C0.606961 2.33611 3.05343 0 6.07131 0H9.53565C12.5535 0 15 2.33611 15 5.21785C15 8.09958 12.5535 10.4357 9.53565 10.4357H6.07131C5.15554 10.4357 4.29238 10.2206 3.53423 9.84039L0 11Z"
        />
      </svg>
      <span v-if="value"
      >{{ value }}
        <span class="reviews-counter__link-text">{{
          [$t('reviews-1'), $t('reviews-2'), $t('reviews-3')] | Pluralize(value)
        }}</span></span
      >
      <span v-else>{{ $t('add_comment') }}</span>
    </a>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Pluralize from '../../filters/Pluralize'
import { isAdaptiveMode } from '@/mixins'

export default {
  name: 'ReviewsCount',
  mixins: [isAdaptiveMode],
  props: {
    value: Number,
    productLink: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    notAdaptive: {
      type: Boolean,
      default: false
    },
    isProductPage: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    Pluralize
  },
  computed: {
    ...mapState({
      initialOffset: state => state.productTabs.initialOffset
    })
  },
  methods: {
    ...mapActions(['SET_ACTIVE_TAB']),
    goToReviews (e) {
      if (this.isProductPage) {
        e.preventDefault()

        const data = {
          string: 'comments',
          top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset - 50
        }

        this.SET_ACTIVE_TAB(data)
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.reviews-counter
  display: flex
  flex-flow: row nowrap
  align-items: center

  font-weight: 400 // Rubik 300
  font-size: 12px
  line-height: 14px
  color: $placeholder-color

.product-card:not(.product-card--not--adaptive) .reviews-counter--empty:not(.reviews-counter--not--adaptive)
  display: none

  +mmin($tablet)
    display: flex

.reviews-counter--medium
  font-size: 14px
  line-height: 17px

  .reviews-counter__svg
    margin-right: 5px

    +mmin($tablet)
      margin-right: 10px

.reviews-counter__svg
  fill: #ccc
  margin-right: 5px

.reviews-counter__link
  display: flex
  align-items: center
  min-height: 17px

.reviews-counter:not(.reviews-counter--empty) .reviews-counter__link span
  text-decoration: underline

.reviews-counter__link-text
  display: none

.reviews-counter--not--adaptive .reviews-counter__link-text
  display: inline
</style>
